"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 800px (typically past the hero and first few paragraphs)
      if (window.scrollY > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          className="fixed bottom-6 inset-x-0 z-[100] px-4 pointer-events-none"
        >
          <div className="max-w-xl mx-auto pointer-events-auto">
            <div className="bg-surface-solid/80 backdrop-blur-2xl border border-brand-1/30 rounded-2xl p-4 shadow-[0_20px_50px_rgba(0,0,0,0.5),0_0_30px_rgba(91,91,255,0.2)] flex items-center justify-between gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-brand-1/10 flex items-center justify-center text-brand-1 hidden sm:flex">
                  <Sparkles className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm leading-tight">
                    Build your Social Media Second Brain
                  </p>
                  <p className="text-text-muted text-[10px] uppercase tracking-wider mt-0.5">
                    Free forever for individuals
                  </p>
                </div>
              </div>
              
              <Link
                href="/sign-in"
                className="flex items-center gap-2 px-5 py-2.5 bg-brand-1 text-white text-xs font-black rounded-xl hover:shadow-[0_0_20px_rgba(91,91,255,0.4)] transition-all whitespace-nowrap uppercase tracking-widest"
              >
                Join Now <ArrowRight className="w-3 h-3" />
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
